import "Layouts/default";
import { addRules } from "Components/form/validate-methods";

$(function () {
    $(".js-form-lost-password").validate({
        submitHandler: function (form) {
            form.submit();
        },
    });

    setTimeout(() => {
        for (const formElem of document.querySelectorAll(".js-form-reg-b2c")) {
            addRules(formElem, ["addressInputs"]);
        }

        for (const formElem of document.querySelectorAll(".js-form-reg-b2b")) {
            addRules(formElem, ["addressInputs"]);
        }
    }, 250);
});

const assignHiddenFields = (autocompleteField, data) => {
    const form = autocompleteField.closest("form");
    const billing = form.querySelector(".js-b2b-reg-billing");

    if (billing) {
        billing.classList.remove("h-nodisplay");

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll("input, select")) {
                $(input).valid();
            }
        }
    }
};

rEvent.on("Finstat.select.after", (autocompleteField, data) => {
    assignHiddenFields(autocompleteField, data);
});

const icDphToggle = document.querySelector(".js-toggle-icdph");

if (icDphToggle) {
    function checkIcdph(icDphToggle) {
        const isChecked = icDphToggle.checked;
        const icDphWrapper = document.querySelector(".js-icdph-wrapper");
        const icDph = icDphWrapper.querySelector(".c-form__input");

        if (isChecked) {
            icDph.required = true;
            icDph.disabled = false;
            icDph.closest(".c-form__item").classList.add("is-required");
        } else {
            icDph.required = false;
            icDph.disabled = true;
            icDph.value = "";
            icDph.focus();
            icDph.blur();
            icDph.closest(".c-form__item").classList.remove("is-required");
        }
    }

    icDphToggle.addEventListener("change", function () {
        checkIcdph(icDphToggle);
    });

    document.addEventListener("DOMContentLoaded", function () {
        checkIcdph(icDphToggle);
    });
}
